import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { CurrencyContext } from '../config/CurrencyContext';
import Translations from '@h/translation';
import { TranslationContext } from '@c/Translations';
import { PaymentContextProvider } from '@showclix-shared/Payment/contexts/PaymentContext';
import EmailOptOutContainer from '@/views/checkout/containers/EmailOptOutContainer';
import QuestionOptInContainer from '@/views/checkout/containers/QuestionOptInContainer';
import TermsOfServiceContainer from "@/views/checkout/containers/TermsOfServiceContainer";
import StepActionContainer from '@/views/checkout/containers/StepActionContainer';
import LocalizedAddress from '@/views/member/components/LocalizedAddress';
import InsuranceContainer from '@/views/insurance/containers/InsuranceContainer';
import LoyaltyProgramContainer from '@/views/loyalty-programs/containers/LoyaltyProgramContainer';
import { PaymentPlans } from '@v/payment-plans/components/PaymentPlans';
import { FocusTrapProvider } from '../contexts/FocusTrapContext';
import NavigationService from '@/components/NavigationService';
import { HashRouter, Routes, Route, useNavigate } from 'react-router';
import { getListingItem } from '@b/listing/helpers/storage';
import { buildPathFromRouteName } from '@h/withRouterCompat';

class EmbeddedComponentWrapper extends React.Component {

    constructor(props) {
        super(props);
        this.t = new Translations(this.props.apiUrl);
        this.t.init('en_US', props.translations);
    }

    render() {
        return (
            <TranslationContext.Provider value={this.t}>
                <FocusTrapProvider>
                    <PaymentContextProvider value={{
                        TranslationContext,
                        LocalizedAddress,
                        StepAction: StepActionContainer,
                        LoyaltyProgram: <LoyaltyProgramContainer />,
                        Insurance: <InsuranceContainer />,
                        PaymentPlans: <PaymentPlans />,
                        OptInsOuts: (
                            <>
                              <TermsOfServiceContainer />
                              <EmailOptOutContainer />
                              <QuestionOptInContainer />
                            </>
                        ),
                    }}>
                        <CurrencyContext.Provider value={this.props.currencyConfig}>
                          <HashRouter>
                            <NavigationService isEmbed={true}/>
                            <Routes>
                              <Route path="*" element={<PersistEmbedRouterHydrator />} />
                            </Routes>
                            {this.props.children}
                          </HashRouter>
                        </CurrencyContext.Provider>
                    </PaymentContextProvider>
                </FocusTrapProvider>
            </TranslationContext.Provider>
        )
    }
}

let rehydratedEmbedRouterState = false;
function PersistEmbedRouterHydrator() {
  const navigate = useNavigate();
  const isEmbed = useSelector((s) => s.ui.isEmbed);
  const currentRouteName = useSelector((s) => s.ui.currentRouteName);
  const listing = useSelector((s) => s.ui.listingSlug);
  const token = getListingItem(listing, "token")

  useEffect(() => {
    // go back to where the router was at before the page was refreshed/reloaded
    if (isEmbed && !rehydratedEmbedRouterState) {
      rehydratedEmbedRouterState = true;
      if (currentRouteName !== 'ticketPicker') {
        const path = buildPathFromRouteName(currentRouteName, token ? { token } : {});
        navigate(path);
        return;
      }
    }
  }, []);

  return null;
}

const mapStateToProps = (state, props) => {
    return {
        currencyConfig: state.ui.currencyConfig,
    }
}

export default connect(mapStateToProps)(EmbeddedComponentWrapper);
